import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { dingtalk, vueUtils } from '../utils';
var openData = dingtalk.openData;
export default {
  name: 'YxtbizDdOpenData',
  props: {
    type: {
      type: String,
      required: true,
      validator: function validator(val) {
        return ['userName', 'userTitle', 'deptName'].includes(val);
      }
    },
    openid: {
      type: String,
      required: true,
      default: ''
    }
  },
  watch: {
    openid: function openid(_openid) {
      // 通常拿到接口数据才渲染列表，openid初始就有值 所以watch很难触发, 需要在mounted触发更新
      if (window.DTOpenData && _openid) {
        var _this$$el;

        // 人员离职后，钉钉无法返回用户名/部门名, dt-open-data为空白
        // 若dt-open-data元素在列表/表格行中被复用，被复用的dt-open-data元素openid变了，但是shadowroot没更新，造成信息错乱
        // 所以openid变化，先清空shadowroot的原有用户名
        if (openData.isMyAttachShadow && (_this$$el = this.$el) != null && _this$$el.shadowRoot) {
          var firstChild = this.$el.shadowRoot.childNodes[0];

          if (firstChild) {
            firstChild.textContent = '';
          }
        } // 只更新自己，多个组件，会出现 DTOpenData.update频繁调用；所以用下面的方法优化一下
        // window.DTOpenData.update([this.$el]);
        // openData.debUpdate(this.$el);


        openData.debUpdate();
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // document.querySelectorAll('dt-open-data') 并不能得到全量的open-data节点
              // 因为有的 ww-open-data 被tooltip包装，并没有渲染到页面上
              openData.addElement(_this.$el);

              if (openData.isStarted()) {
                _context.next = 6;
                break;
              }

              _context.next = 4;
              return openData.init();

            case 4:
              _context.next = 7;
              break;

            case 6:
              if (openData.isReady()) {
                openData.debUpdate(_this.$el); // openData.update();
              }

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  updated: function updated() {
    openData.addElement(this.$el); // 若dt-open-data, 加key, 需要在渲染完后，才能得到最新元素
  },
  render: function render(h) {
    h = vueUtils.geth(h);
    return h('dt-open-data', _extends({}, openData.isMyAttachShadow ? {} : {
      key: this.openid
    }, {
      attrs: {
        'open-type': this.type,
        'open-id': this.openid
      }
    }));
  }
};